module.exports = __webpack_public_path__ + "static/media/indigenous-small.388de9c4.mp4";